import { apiFetch } from '../../auth/apiFetch';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071/api';

// Import guards return {error: <code>, message: <operator-facing sentence>}.
// Surfacing `error` alone puts a bare code like "duplicate_target_field" on
// screen and throws away the sentence that names what to fix. Prefer `message`,
// fall back to `error` for older/unexpected shapes, then to a generic label, so
// a response that carries neither still shows something rather than nothing.
async function errorText(res, fallback) {
  try {
    const body = await res.json();
    return body.message || body.error || fallback;
  } catch {
    return fallback;
  }
}

export async function parseImportFile({ file, siteId, callerEmail }) {
  const form = new FormData();
  form.append("file", file);
  form.append("site_id", siteId);
  form.append("caller_email", callerEmail);
  const res = await apiFetch(`${API_BASE_URL}/import_data`, { method: "POST", body: form });
  if (!res.ok) throw new Error(await errorText(res, "Parse failed"));
  return res.json();
}

export async function validateImport({ blobName, siteId, mapping, callerEmail }) {
  const res = await apiFetch(`${API_BASE_URL}/import_data`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "validate", blob_name: blobName, site_id: siteId, mapping, caller_email: callerEmail }),
  });
  if (!res.ok) throw new Error(await errorText(res, "Validate failed"));
  return res.json();
}

export async function commitImport({ blobName, siteId, mapping, callerEmail }) {
  const res = await apiFetch(`${API_BASE_URL}/import_data`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "commit", blob_name: blobName, site_id: siteId, mapping, caller_email: callerEmail }),
  });
  if (!res.ok) throw new Error(await errorText(res, "Commit failed"));
  return res.json();
}

export async function exportData({ siteId, fields, callerEmail }) {
  const res = await apiFetch(`${API_BASE_URL}/export_data`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ caller_email: callerEmail, site_id: siteId, fields }),
  });
  if (!res.ok) throw new Error(await errorText(res, "Export failed"));
  return res.json(); // { download_url, filename, row_count, tool_count }
}

// --- Data Exchange Profiles ---

export async function listProfiles(type, callerEmail) {
  const params = new URLSearchParams({ type, caller_email: callerEmail });
  const res = await apiFetch(`${API_BASE_URL}/manage_data_exchange_profiles?${params}`);
  if (!res.ok) throw new Error(await errorText(res, "List profiles failed"));
  return res.json();
}

export async function saveProfile(type, name, profile, callerEmail) {
  const res = await apiFetch(`${API_BASE_URL}/manage_data_exchange_profiles`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "save", type, name, profile, caller_email: callerEmail }),
  });
  if (!res.ok) throw new Error(await errorText(res, "Save profile failed"));
  return res.json();
}

export async function deleteProfile(profileId, callerEmail) {
  const res = await apiFetch(`${API_BASE_URL}/manage_data_exchange_profiles`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "delete", profile_id: profileId, caller_email: callerEmail }),
  });
  if (!res.ok) throw new Error(await errorText(res, "Delete profile failed"));
  return res.json();
}
